import { SEOHead } from "@/components/SEOHead";
import { Header } from "@/components/layout/Header";
import { Footer } from "@/components/layout/Footer";

const WhySons = () => {
  return (
    <div className="min-h-screen">
      <SEOHead
        title="Why Choose Son's Guadalupe | Private Guadalupe River Experience"
        description="See why families choose Son's Guadalupe over other Guadalupe River spots. Private cabanas, family-friendly atmosphere, clean facilities, and your float ends at your doorstep."
        canonical="/why-sons"
      />
      <Header />
      <main className="pt-24">
        <section className="section-padding bg-background">
          <div className="container-narrow mx-auto text-center">
            <h1 className="font-heading text-4xl md:text-5xl font-bold text-foreground mb-6">
              Why Son's Guadalupe Is Different
            </h1>
            <p className="text-muted-foreground text-lg max-w-2xl mx-auto">
              We built Son's Guadalupe to fix every part of the river experience that usually goes wrong.
            </p>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
};

export default WhySons;
